import { Link, Text, Stack, ImageIcon } from '@/components/lib'
import useStore from '@/store'

// The build the app was made from (short git SHA, set by the deploy
// workflow; 'dev' when running locally) and the API's, which arrives on
// every response. Both are what to quote when reporting a problem, and
// what the event log's `version` column refers to.
const WEB_VERSION = import.meta.env.VITE_APP_VERSION || 'dev'

export default function Footer () {
  const apiVersion = useStore(state => state.apiVersion)
  return (
    <Stack direction='row' bg='bg.subtle' borderTopWidth='1px' borderColor='border.default' p={1} px={2} alignItems='center' justifyContent='space-between'>
      <Stack direction='row' alignItems='center'>
        <ImageIcon iconKey='trialflare' size={30} p={1} />
        <Text fontSize='xs' fontWeight='semibold' color='fg.muted'>Powered by Trialflare<br /><small>&copy; {new Date().getFullYear()} Seastorm Limited</small></Text>
        <Text fontSize='xs' color='fg.subtle' fontFamily='mono' title='Build versions: web app and API' ml={2}>
          web {WEB_VERSION}{apiVersion && ` · api ${apiVersion}`}
        </Text>
      </Stack>
      <Stack direction={['column', 'row']} alignItems='center' textAlign='right' gap={4} fontSize='sm'>
        <Link as='a' href='https://trialflare.com/privacy' target='_blank' rel='noopener noreferrer'>Privacy Policy</Link>
        <Link as='a' href='https://trialflare.com/legal' target='_blank' rel='noopener noreferrer'>Terms of Use</Link>
      </Stack>
    </Stack>
  )
}
